import {GeneralInterface} from "./General.interface";
import {HeaderSchema} from "@/views/Admin/Events/Event/General/Header/Header.schema";
import {InfoSchema} from "@/views/Admin/Events/Event/General/Info/Info.schema";

export const GeneralSchema: GeneralInterface = {
    ...HeaderSchema,
    ...InfoSchema,
    constants: null,
    permissions: null,
    eventType: null,
    isLoading: false,
}
